export const admin = {
  layout: {
    home: 'Accueil',
  },
  
  sidebar: {
    dashboard: 'Tableau de bord',
    agencies: 'Agences',
    cars: 'Voitures',
    clients: 'Clients',
    bookings: 'Réservations',
    factures: 'Factures',
    stats: 'Statistiques',
    users: 'Utilisateurs',
    vehicles: 'Véhicules',
    payments: 'Paiements',
    reports: 'Rapports',
    documents: 'Documents',
    security: 'Sécurité',
    settings: 'Paramètres',
    help: 'Aide et Support',
    brandsModels: 'Marques et Modèles',
  },
  
  // Dashboard
  title: 'Tableau de bord Admin',
  subtitle: 'Gérez votre plateforme KiraCar',
  
  // Overview
  totalUsers: 'Total Utilisateurs',
  totalVehicles: 'Total Véhicules',
  monthlyRevenue: 'Revenus Mensuels',
  platformActivity: 'Activité de la Plateforme',
  
  // Dashboard Cards (Root level for component access)
  totalAgencies: 'Total Agences',
  active: 'actives',
  totalCars: 'Total Voitures',
  acrossAllAgencies: 'Dans toutes les agences',
  totalRevenue: 'Chiffre d\'Affaires Total',
  allTimeRevenue: 'Chiffre d\'affaires de tous les temps',
  selected: 'Sélectionné',
  searchAgencies: 'Rechercher des agences',
  columns: 'Colonnes',
  showingAgencies: 'Affichage de {{count}} sur {{total}} agences',
  allCities: 'Toutes les Villes',
  filters: 'Filtres',
  
  // Cars Admin Page Keys
  totalBookings: 'Total Réservations',
  acrossAllCars: 'Dans toutes les voitures',
  available: 'Disponibles',
  allAgencies: 'Toutes les Agences',
  allCategories: 'Toutes les Catégories',
  searchCars: 'Rechercher des voitures',
  
  // Additional Agency Admin Keys
  allAgencyLocations: 'Tous les emplacements de l\'agence',
  allReviewsAndRatings: 'Tous les avis et évaluations',
  allNotifications: 'Toutes les notifications',
  
  // Agency Deletion Dialog Keys
  cancel: 'Annuler',
  yesDeleteEverything: 'Oui, tout supprimer',
  
  // Clients Admin Page Keys
  verifiedClients: 'Clients Vérifiés',
  totalClients: 'Total Clients',
  searchClients: 'Rechercher des clients',
  showingClients: 'Affichage de {{count}} sur {{total}} clients',
  allVerification: 'Toutes les Vérifications',
  fromAllClients: 'De tous les clients',
  
  // Users
  userManagement: 'Gestion des Utilisateurs',
  agencyOwners: 'Propriétaires d\'Agences',
  administrators: 'Administrateurs',
  
  // Statistics and Analytics
  statistics: 'Statistiques',
  analyticsAndStatistics: 'Analyses et Statistiques',
  comprehensiveInsights: 'Aperçus complets sur les performances de la plateforme',
  last7Days: '7 derniers jours',
  last30Days: '30 derniers jours',
  last90Days: '90 derniers jours',
  selectTimeRange: 'Sélectionner la période',
  vsPreviousPeriod: 'vs période précédente',
  avgBookingValue: 'Valeur Moyenne Réservation',
  perBookingAverage: 'Moyenne par réservation',
  topCitiesByRevenue: 'Top Villes par Chiffre d\'Affaires',
  topAgenciesByPerformance: 'Top Agences par Performance',
  revenueByAgency: 'Chiffre d\'Affaires par Agence',
  monthlyTrends: 'Tendances Mensuelles',
  averageRentalPeriod: 'Période de location moyenne',
  
  // Bookings page specific keys
  completionRate: 'Taux de Réussite',
  fromAllBookings: 'De toutes les réservations',
  searchBookings: 'Rechercher des réservations',
  allPayment: 'Tous les Paiements',
  showingBookings: 'Affichage de {{count}} sur {{total}} réservations',
  
  // Common actions
  view: 'Voir',
  edit: 'Modifier',
  delete: 'Supprimer',
  approve: 'Approuver',
  reject: 'Rejeter',
  activate: 'Activer',
  deactivate: 'Désactiver',
  
  // Common buttons
  export: 'Exporter',
  download: 'Télécharger',
  save: 'Enregistrer',
  saveChanges: 'Enregistrer les Modifications',
  close: 'Fermer',
  changePassword: 'Changer le Mot de Passe',
  mustBeLoggedIn: 'Vous devez être connecté pour effectuer cette action.',
  cancelSelected: 'Annuler la Sélection',
  refresh: 'Actualiser',
  markCompleted: 'Marquer comme Terminé',
  sendSelected: 'Envoyer la Sélection',
  markAsPaid: 'Marquer comme Payé',
  viewInvoice: 'Voir la Facture',
  sendToCustomer: 'Envoyer au Client',
  editInvoice: 'Modifier la Facture',
  editAgency: 'Modifier l\'Agence',
  editClient: 'Modifier le Client',
  editBooking: 'Modifier la Réservation',
  deleteCar: 'Supprimer la Voiture',
  deleteBooking: 'Supprimer la Réservation',
  addAgency: 'Ajouter une Agence',
  addCar: 'Ajouter une Voiture',
  addBooking: 'Ajouter une Réservation',
  addClient: 'Ajouter un Client',
  createInvoice: 'Créer une Facture',
  create: 'Créer',
  actions: 'Actions',
  areYouSure: 'Êtes-vous sûr',
  actionCannotBeUndone: 'Cette action ne peut pas être annulée',
  willPermanentlyDelete: 'Cela supprimera définitivement',
  areYouAbsolutelySure: 'Êtes-vous absolument sûr ?',
  deleteClient: 'Supprimer le Client',
  andAllOf: 'et tout',
  andAllOfTheir: 'et toutes leurs',
  associatedData: 'données associées',
  for: 'pour',
  manageAndTrack: 'Gérer et suivre toutes les factures et paiements',
  editingDetailsFor: 'Modification des détails pour',
  viewingDetailsFor: 'Affichage des détails pour',
  editingBookingFor: 'Modification de la réservation pour',
  viewingBookingDetailsFor: 'Affichage des détails de la réservation pour',
  theFollowingWillBeDeleted: 'Les éléments suivants seront supprimés :',
  bookingFor: 'Réservation pour',
  hasBeenPermanentlyDeleted: 'a été définitivement supprimée',
  invoice: 'FACTURE',
  bookingId: 'ID de Réservation',
  customer: 'Client',
  email: 'Email',
  vehicle: 'Véhicule',
  startDate: 'Date de Début',
  endDate: 'Date de Fin',
  duration: 'Durée',
  totalAmount: 'Montant Total',
  days: 'jours',
  emailSelected: 'Email Sélectionné',
  avgDuration: 'Durée Moyenne',
  fullName: 'Nom Complet',
  phone: 'Téléphone',
  username: 'Nom d\'utilisateur',
  blockSelected: 'Bloquer la Sélection',
  deleteSelected: 'Supprimer la Sélection',
  amount: 'Montant',
  paymentStatus: 'Statut de Paiement',
  generated: 'Généré',
  role: 'Rôle',
  agencyName: 'Nom de l\'Agence',
  country: 'Pays',
  address: 'Adresse',
  description: 'Description',
  notes: 'Notes',
  durationDays: 'Durée (jours)',
  addNotesPlaceholder: 'Ajouter des notes sur cette réservation...',
  noDescriptionProvided: 'Aucune description fournie.',
  generatingInvoice: 'Génération de la facture...',
  unknownCustomer: 'Client Inconnu',
  notAvailable: 'N/D',
  allStatus: 'Tous les Statuts',
  noEmail: 'Aucun email',
  unknownAgency: 'Agence Inconnue',
  bookingsByStatus: 'Réservations par Statut',

  dashboard: {
    title: 'Tableau de Bord Admin',
    overview: 'Aperçu',
    customers: 'Clients',
    agencies: 'Agences',
    vehicles: 'Véhicules',
    analytics: 'Analyses',
    recentActivity: 'Activité Récente',
    quickActions: 'Actions Rapides',
    newAgencyRegistered: 'Nouvelle Agence Enregistrée',
    agencyJoinedPlatform: 'Une nouvelle agence a rejoint la plateforme',
    vehicleAdded: 'Véhicule Ajouté',
    vehicleAddedToInventory: 'Nouveau véhicule ajouté à l\'inventaire',
    bookingCompleted: 'Réservation Terminée',
    customerCompletedRental: 'Client a terminé la location',
    userVerification: 'Vérification Utilisateur',
    newUserVerified: 'Nouveau compte utilisateur vérifié',
    hoursAgo: 'Il y a {{count}} heures',
    manageCustomers: 'Gérer les Clients',
    manageAgencies: 'Gérer les Agences',
    manageVehicles: 'Gérer les Véhicules',
    viewAnalytics: 'Voir les Analyses',
    agencyManagement: 'Gestion des Agences',
    agencyManagementDesc: 'Gérer et surveiller toutes les agences de location sur la plateforme',
    addNewAgency: 'Ajouter une Nouvelle Agence',
    vehicleManagement: 'Gestion des Véhicules',
    vehicleManagementDesc: 'Gérer et surveiller tous les véhicules des agences',
    addNewVehicle: 'Ajouter un Nouveau Véhicule',
    
    // Dashboard Cards
    totalUsers: 'Total Utilisateurs',
    registeredUsers: 'Utilisateurs enregistrés sur la plateforme',
    totalAgencies: 'Total Agences',
    active: 'actives',
    activeAgencies: 'Agences de location actives',
    totalCars: 'Total Voitures',
    acrossAllAgencies: 'Dans toutes les agences',
    totalVehicles: 'Total Véhicules',
    availableVehicles: 'Véhicules disponibles',
    totalRevenue: 'Chiffre d\'Affaires Total',
    allTimeRevenue: 'Chiffre d\'affaires de tous les temps',
    completedBookings: 'Des réservations terminées',
    selected: 'Sélectionné',
    ofSelected: 'de {{total}} sélectionné',
    totalBookings: 'Total Réservations',
    allTimeBookings: 'Réservations de tous les temps',
    activeBookings: 'Réservations Actives',
    currentlyActive: 'Actuellement actives',
    pendingBookings: 'Réservations en Attente',
    awaitingConfirmation: 'En attente de confirmation',
    totalLocations: 'Total Emplacements',
    agencyLocations: 'Emplacements des agences',
    fromLastMonth: 'du mois dernier',
    statsError: 'Erreur de chargement des statistiques'
  },
  
  analytics: {
    errorTitle: 'Erreur d\'Analyse',
    retry: 'Réessayer',
    topAgency: 'Meilleure Agence',
    byRevenue: 'Par chiffre d\'affaires',
    topCategory: 'Meilleure Catégorie',
    mostPopular: 'Plus populaire',
    avgBookingValue: 'Valeur Moyenne Réservation',
    perBooking: 'Par réservation',
    conversionRate: 'Taux de Conversion',
    visitorsToBookings: 'Visiteurs vers réservations',
    agencyPerformance: 'Performance des Agences',
    vehicles: 'Véhicules',
    bookings: 'Réservations',
    revenue: 'Chiffre d\'Affaires',
    rating: 'Note',
    completion: 'Achèvement',
    categoryDistribution: 'Distribution des Catégories'
  },
  
  agencies: {
    title: 'Gestion des Agences',
    subtitle: 'Gérer et surveiller toutes les agences de location',
    all: 'Toutes',
    active: 'Actives',
    pending: 'En Attente',
    suspended: 'Suspendues',
    searchAgencies: 'Rechercher des agences',
    allStatus: 'Tous les Statuts',
    allCities: 'Toutes les Villes',
    filters: 'Filtres',
    columns: 'Colonnes',
    showingAgencies: 'Affichage de {{count}} sur {{total}} agences',
    errorTitle: 'Échec du Chargement des Agences',
    retry: 'Réessayer',
    website: 'Site Web',
    vehicles: 'Véhicules',
    bookings: 'Réservations',
    revenue: 'Chiffre d\'Affaires',
    rating: 'Note',
    completion: 'Achèvement',
    lastActivity: 'Dernière Activité',
    joinedOn: 'Inscrit le',
    locations: 'Emplacements',
    more: 'plus',
    noAgencies: 'Aucune Agence Trouvée',
    noAgenciesDesc: 'Aucune agence ne correspond aux filtres actuels',
    yesterday: 'Hier',
    daysAgo: 'Il y a {{count}} jours',
    weeksAgo: 'Il y a {{count}} semaines',
    monthsAgo: 'Il y a {{count}} mois',
    
    // Table columns
    name: 'Nom de l\'Agence',
    email: 'Email',
    phone: 'Téléphone',
    city: 'Ville',
    country: 'Pays',
    cars: 'Voitures',
    status: 'Statut',
    username: 'Nom d\'utilisateur',
    address: 'Adresse',
    
    // Filters
    
    // Actions
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    actions: 'Actions',
    
    // Dialog
    agencyDetails: 'Détails de l\'Agence',
    editAgency: 'Modifier l\'Agence',
    noUsername: 'Aucun nom d\'utilisateur',
    
    // Messages
    fetchError: 'Échec du chargement des agences',
    deleteError: 'Échec de la suppression de l\'agence',
    deleteSuccess: 'Agence supprimée avec succès',
    updateSuccess: 'Agence mise à jour avec succès',
    updateError: 'Échec de la mise à jour de l\'agence',
    deleteFailed: 'Échec de la suppression de l\'agence',
    permissionDenied: 'Permission refusée. Vous n\'avez peut-être pas les droits nécessaires pour supprimer cette agence.',
    
    // Common placeholders
    min: 'Min',
    max: 'Max',
    
    // Password management
    newPassword: 'Nouveau mot de passe',
    enterNewPassword: 'Entrez un nouveau mot de passe (min. 6 caractères)',
    passwordHint: 'Laissez vide pour conserver le mot de passe actuel. Minimum 6 caractères.',
    generatePassword: 'Générer un mot de passe aléatoire',
    sendPasswordEmail: 'Envoyer le mot de passe par email',
    passwordRequired: 'Veuillez d\'abord générer ou saisir un mot de passe.',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères.',
    ownerNotFound: 'Impossible de trouver le propriétaire de l\'agence.',
    ownerEmailNotFound: 'Impossible de trouver l\'adresse email du propriétaire.',
    emailSendFailed: 'Échec de l\'envoi de l\'email',
    passwordEmailSent: 'Le mot de passe a été envoyé à l\'email du propriétaire de l\'agence.',
    emailSendError: 'Échec de l\'envoi de l\'email avec le mot de passe. Veuillez réessayer.'
  },
  
  vehicles: {
    title: 'Gestion des Véhicules',
    subtitle: 'Gérer et surveiller tous les véhicules des agences',
    totalVehicles: 'Total Véhicules',
    acrossAllAgencies: 'Dans toutes les agences',
    averagePrice: 'Prix Moyen',
    perDay: 'Par jour',
    utilization: 'Taux d\'Utilisation',
    averageUtilization: 'Utilisation moyenne',
    topCategory: 'Meilleure Catégorie',
    mostPopular: 'Plus populaire',
    allCategories: 'Toutes les Catégories',
    all: 'Tous',
    available: 'Disponibles',
    rented: 'Loués',
    maintenance: 'Maintenance',
    unavailable: 'Indisponibles',
    errorTitle: 'Échec du Chargement des Véhicules',
    retry: 'Réessayer',
    seats: 'places',
    bookings: 'Réservations',
    revenue: 'Chiffre d\'Affaires',
    rating: 'Note',
    lastBooked: 'Dernière Réservation',
    noVehicles: 'Aucun Véhicule Trouvé',
    noVehiclesDesc: 'Aucun véhicule ne correspond aux filtres actuels',
    yesterday: 'Hier',
    daysAgo: 'Il y a {{count}} jours',
    weeksAgo: 'Il y a {{count}} semaines',
    monthsAgo: 'Il y a {{count}} mois'
  },

  cars: {
    title: 'Voitures',
    subtitle: 'Gérer et surveiller toutes les voitures des agences',
    totalCars: 'Total Voitures',
    acrossAllAgencies: 'Dans toutes les agences',
    averagePrice: 'Prix Moyen',
    perDay: 'Par jour',
    utilization: 'Taux d\'Utilisation',
    averageUtilization: 'Utilisation moyenne',
    topCategory: 'Meilleure Catégorie',
    mostPopular: 'Plus populaire',
    allCategories: 'Toutes les Catégories',
    all: 'Toutes',
    errorTitle: 'Échec du Chargement des Voitures',
    retry: 'Réessayer',
    bookings: 'Réservations',
    revenue: 'Chiffre d\'Affaires',
    rating: 'Note',
    lastBooked: 'Dernière Réservation',
    noCars: 'Aucune Voiture Trouvée',
    noCarsDesc: 'Aucune voiture ne correspond aux filtres actuels',
    yesterday: 'Hier',
    daysAgo: 'Il y a {{count}} jours',
    weeksAgo: 'Il y a {{count}} semaines',
    monthsAgo: 'Il y a {{count}} mois',
    
    // Table columns
    make: 'Marque',
    model: 'Modèle',
    year: 'Année',
    color: 'Couleur',
    category: 'Catégorie',
    transmission: 'Transmission',
    fuelType: 'Type de Carburant',
    seats: 'Places',
    pricePerDay: 'Prix/Jour',
    availability: 'Disponible',
    agency: 'Agence',
    bookingCount: 'Réservations',
    created: 'Créé',
    
    // Filters
    status: 'Statut',
    
    // Status labels
    available: 'Disponible',
    rented: 'Louée',
    maintenance: 'Maintenance',
    unavailable: 'Indisponible',
    
    // Actions
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    actions: 'Actions',
    
    // Dialog
    carDetails: 'Détails de la Voiture',
    editCar: 'Modifier la Voiture',
    viewCarInfo: 'Voir les informations détaillées de cette voiture',
    editCarInfo: 'Modifier les informations de la voiture',
    description: 'Description',
    noDescription: 'Aucune description',
    selectTransmission: 'Sélectionner la transmission',
    selectAvailability: 'Sélectionner la disponibilité',
    close: 'Fermer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    deleting: 'Suppression...',
    deleteCar: 'Supprimer la Voiture',
    
    // Messages
    fetchError: 'Échec du chargement des voitures',
    deleteError: 'Impossible de supprimer une voiture avec des réservations actives',
    deleteSuccess: 'Voiture supprimée avec succès',
    updateSuccess: 'Voiture mise à jour avec succès',
    updateError: 'Échec de la mise à jour de la voiture',
    deleteFailed: 'Échec de la suppression de la voiture',
    
    // CSV Export
    csvHeaders: ['Marque', 'Modèle', 'Année', 'Couleur', 'Catégorie', 'Transmission', 'Type de Carburant', 'Places', 'Prix/Jour', 'Agence', 'Réservations', 'Chiffre d\'Affaires', 'Statut', 'Créé']
  },
  
  customers: {
    title: 'Gestion des Clients',
    subtitle: 'Gérer et surveiller tous les clients',
    totalCustomers: 'Total Clients',
    activeCustomers: 'Clients Actifs',
    verifiedCustomers: 'Clients Vérifiés',
    newThisMonth: 'Nouveaux ce mois',
    errorTitle: 'Échec du Chargement des Clients',
    retry: 'Réessayer'
  },

  bookings: {
    title: 'Réservations',
    subtitle: 'Gérer et surveiller toutes les réservations',
    totalBookings: 'Total Réservations',
    activeBookings: 'Réservations Actives',
    completedBookings: 'Réservations Terminées',
    cancelledBookings: 'Réservations Annulées',
    errorTitle: 'Échec du Chargement des Réservations',
    retry: 'Réessayer',
    
    // Table columns
    bookingId: 'ID Réservation',
    customer: 'Client',
    agency: 'Agence',
    carMake: 'Marque Voiture',
    carModel: 'Modèle Voiture',
    startDate: 'Date de Début',
    endDate: 'Date de Fin',
    duration: 'Durée',
    amount: 'Montant',
    status: 'Statut',
    payment: 'Paiement',
    created: 'Créé',
    customerEmail: 'Email Client',
    pickupLocation: 'Lieu de Récupération',
    returnLocation: 'Lieu de Retour',
    
    // Filters
    
    // Status labels
    pending: 'En Attente',
    confirmed: 'Confirmé',
    active: 'Actif',
    completed: 'Terminé',
    cancelled: 'Annulé',
    
    // Payment status
    paid: 'Payé',
    failed: 'Échoué',
    refunded: 'Remboursé',
    
    // Actions
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    actions: 'Actions',
    downloadInvoice: 'Télécharger Facture',
    markCompleted: 'Marquer Terminé',
    cancel: 'Annuler',
    resendWhatsApp: 'Renvoyer WhatsApp',
    
    // Resend WhatsApp dialog
    resendWhatsAppTitle: 'Renvoyer la notification WhatsApp',
    resendWhatsAppDescription: 'Modifiez les variables du modèle ci-dessous et envoyez la notification de nouvelle réservation au propriétaire de l\'agence.',
    resendWhatsAppBooking: 'Réservation',
    resendWhatsAppSend: 'Envoyer WhatsApp',
    whatsappVarId: 'ID',
    whatsappVarClient: 'Client',
    whatsappVarCarMake: 'Marque',
    whatsappVarCarModel: 'Modèle',
    whatsappVarDepart: 'Départ (date)',
    whatsappVarRetour: 'Retour (date)',
    whatsappVarPrix: 'Prix Total',
    whatsappVarTele: 'Télé',
    
    // Dialog
    bookingDetails: 'Détails de la Réservation',
    editBooking: 'Modifier la Réservation',
    selectStatus: 'Sélectionner le statut',
    selectPaymentStatus: 'Sélectionner le statut de paiement',
    
    // Messages
    fetchError: 'Échec du chargement des réservations',
    deleteError: 'Échec de la suppression de la réservation',
    deleteSuccess: 'Réservation supprimée avec succès',
    updateSuccess: 'Réservation mise à jour avec succès',
    updateError: 'Échec de la mise à jour de la réservation',
    deleteFailed: 'Échec de la suppression de la réservation',
    permissionDenied: 'Permission refusée. Vous n\'avez peut-être pas les droits nécessaires pour supprimer cette réservation.',
    bookingDataNotFound: 'Données de réservation non trouvées',
    invoiceDownloaded: 'Facture téléchargée avec succès',
    bookingCompleted: 'Réservation marquée comme terminée',
    bookingCancelled: 'Réservation annulée',
    whatsappNotificationFailed: 'Réservation créée mais l\'envoi WhatsApp a échoué',
    whatsappResendSuccess: 'Notification WhatsApp envoyée avec succès',
    
    // Placeholders
    noCustomer: 'Aucun Client',
    noEmail: 'Aucun email',
    unknownAgency: 'Agence Inconnue',
    unknown: 'Inconnu',
    notSpecified: 'Non spécifié',
    
    // Common placeholders
    min: 'Min',
    max: 'Max',
    
    // Booking creation dialog
    createBooking: 'Créer une Réservation',
    createBookingDescription: 'Créer une nouvelle réservation pour n\'importe quelle agence',
    selectAgency: 'Sélectionner une Agence',
    selectCustomer: 'Sélectionner un Client',
    selectCar: 'Sélectionner une Voiture',
    agencyRequired: 'L\'agence est requise',
    customerRequired: 'Le client est requis',
    carRequired: 'La voiture est requise',
    datesRequired: 'Les dates de début et de fin sont requises',
    startTime: 'Heure de Début',
    endTime: 'Heure de Fin',
    calculatePrice: 'Calculer le Prix',
    bookingCreated: 'Réservation créée avec succès',
    createBookingError: 'Échec de la création de la réservation',
    totalPrice: 'Prix Total',
    createNewCustomer: 'Créer un Nouveau Client',
    customerName: 'Nom du Client',
    customerPhone: 'Téléphone du Client',
    noAgenciesFound: 'Aucune agence trouvée',
    noCustomersFound: 'Aucun client trouvé',
    noCarsFound: 'Aucune voiture trouvée pour l\'agence sélectionnée',
    pricePerDay: 'Prix par jour'
  },
  
  users: {
    title: 'Gestion des Utilisateurs',
    management: 'Gestion des Utilisateurs',
    subtitle: 'Gérer et surveiller tous les utilisateurs de la plateforme'
  },

  clients: {
    title: 'Clients',
    subtitle: 'Gérer et surveiller tous les clients',
    totalClients: 'Total Clients',
    activeClients: 'Clients Actifs',
    verifiedClients: 'Clients Vérifiés',
    newThisMonth: 'Nouveaux ce mois',
    errorTitle: 'Échec du Chargement des Clients',
    retry: 'Réessayer',
    
    // Table columns
    clientName: 'Nom du Client',
    email: 'Email',
    phone: 'Téléphone',
    bookings: 'Réservations',
    totalSpent: 'Total Dépensé',
    lastBooking: 'Dernière Réservation',
    status: 'Statut',
    verification: 'Vérification',
    joined: 'Inscrit',
    role: 'Rôle',
    
    // Filters
    
    // Status labels
    active: 'Actif',
    inactive: 'Inactif',
    suspended: 'Suspendu',
    
    // Verification status
    verified: 'Vérifié',
    unverified: 'Non Vérifié',
    pending: 'En Attente',
    
    // Actions
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    actions: 'Actions',
    
    // Dialog
    clientDetails: 'Détails du Client',
    editClient: 'Modifier le Client',
    
    // Messages
    fetchError: 'Échec du chargement des clients',
    deleteError: 'Échec de la suppression du client',
    deleteSuccess: 'Client supprimé avec succès',
    updateSuccess: 'Client mis à jour avec succès',
    updateError: 'Échec de la mise à jour du client',
    deleteFailed: 'Échec de la suppression du client',
    permissionDenied: 'Permission refusée. Vous n\'avez peut-être pas les droits nécessaires pour supprimer ce client.',
    
    // Placeholders
    client: 'Client',
    noName: 'Aucun nom',
    noPhone: 'Aucun téléphone',
    never: 'Jamais',
    
    // Common placeholders
    min: 'Min',
    max: 'Max'
  },
  
  settings: {
    title: 'Paramètres Admin',
    subtitle: 'Configurer les paramètres et préférences de la plateforme',
    general: 'Général',
    platform: 'Plateforme',
    security: 'Sécurité',
    notifications: 'Notifications',
    
    // General Settings
    platformName: 'Nom de la Plateforme',
    platformDescription: 'Description de la Plateforme',
    defaultLanguage: 'Langue par Défaut',
    timezone: 'Fuseau Horaire',
    currency: 'Devise par Défaut',
    
    // Platform Settings
    maintenanceMode: 'Mode Maintenance',
    maintenanceModeDesc: 'Activer le mode maintenance pour empêcher l\'accès des utilisateurs',
    userRegistration: 'Inscription Utilisateur',
    userRegistrationDesc: 'Permettre aux nouveaux utilisateurs de s\'inscrire sur la plateforme',
    agencyRegistration: 'Inscription Agence',
    agencyRegistrationDesc: 'Permettre aux nouvelles agences de s\'inscrire sur la plateforme',
    
    // Security Settings
    passwordPolicy: 'Politique de Mot de Passe',
    passwordPolicyDesc: 'Configurer les exigences de mot de passe',
    twoFactorAuth: 'Authentification à Deux Facteurs',
    twoFactorAuthDesc: 'Exiger 2FA pour les comptes admin',
    emailVerification: 'Vérification Email',
    emailVerificationDesc: 'Exiger la vérification email pour les nouvelles inscriptions',
    sessionTimeout: 'Expiration de Session',
    sessionTimeoutDesc: 'Déconnecter automatiquement les utilisateurs inactifs',
    
    // Notification Settings
    emailNotifications: 'Notifications Email',
    emailNotificationsDesc: 'Envoyer des notifications email pour les événements importants',
    smsNotifications: 'Notifications SMS',
    smsNotificationsDesc: 'Envoyer des notifications SMS pour les alertes critiques',
    
    // Watermark Settings
    watermark: 'Filigrane d\'Image',
    watermarkEnabled: 'Activer le Filigrane',
    watermarkEnabledDesc: 'Ajouter un filigrane à toutes les images de voitures',
    watermarkImage: 'Image du Filigrane',
    watermarkChangeImage: 'Changer l\'Image',
    watermarkUploadImage: 'Télécharger l\'Image',
    watermarkUpload: 'Télécharger',
    watermarkUploading: 'Téléchargement...',
    watermarkImageUploaded: 'Image du filigrane téléchargée avec succès',
    watermarkImageLoadError: 'Image introuvable',
    watermarkRemove: 'Supprimer',
    watermarkImageHelp: 'Recommandé: PNG avec fond transparent, max 5MB. Le filigrane conservera son ratio d\'aspect.',
    watermarkCurrentImage: 'L\'image du filigrane actuelle est active',
    watermarkOpacity: 'Opacité',
    watermarkOpacityDesc: 'Transparence du filigrane (0-100%)',
    watermarkSize: 'Taille',
    watermarkSizeDesc: 'Taille du filigrane en pourcentage de la largeur de l\'image (5-50%)',
    watermarkPreview: 'Aperçu du Filigrane',
    watermarkPreviewDesc: 'Aperçu sur image de voiture réelle de la base de données',
    watermarkShowPreview: 'Afficher l\'Aperçu',
    watermarkLoadingCar: 'Chargement de l\'image de voiture...',
    watermarkGenerating: 'Génération de l\'aperçu...',
    watermarkPreviewError: 'Échec du chargement de l\'image d\'aperçu',
    watermarkPreviewErrorHelp: 'L\'aperçu utilisera le filigrane côté client comme solution de secours.',
    watermarkPreviewFallback: 'Utilisation de l\'image originale - aperçu du filigrane indisponible',
    watermarkDisabled: 'Le filigrane est désactivé. Activez-le pour voir l\'aperçu.',
    watermarkPreviewNote: 'Cet aperçu utilise une vraie image de voiture de votre base de données et montre exactement comment le filigrane apparaîtra sur votre site.',
    
    // Actions
    save: 'Enregistrer les Paramètres',
    saving: 'Enregistrement...',
    saved: 'Paramètres enregistrés avec succès',
    error: 'Erreur lors de l\'enregistrement des paramètres',
    
    // Pagination
    showing: 'Affichage',
    to: 'à',
    of: 'sur',
    results: 'résultats',
    perPage: 'par page'
  },

  // Brands & Models Management
  brandsModels: {
    title: 'Gestion des Marques et Modèles',
    subtitle: 'Gérer les marques et modèles de voitures',
    brands: 'Marques',
    models: 'Modèles',
    totalBrands: 'Total des Marques',
    totalModels: 'Total des Modèles',
    
    // Brand management
    brandName: 'Nom de la Marque',
    logoUrl: 'URL du Logo',
    modelCount: 'Nombre de Modèles',
    createdAt: 'Créé le',
    addBrand: 'Ajouter une Marque',
    editBrand: 'Modifier la Marque',
    deleteBrand: 'Supprimer la Marque',
    addBrandDescription: 'Ajouter une nouvelle marque de voiture au système',
    editBrandDescription: 'Modifier la marque de voiture sélectionnée',
    deleteBrandConfirm: 'Êtes-vous sûr de vouloir supprimer la marque "{{name}}" ? Cette action ne peut pas être annulée.',
    brandNamePlaceholder: 'Entrez le nom de la marque (ex: Toyota)',
    logoUrlPlaceholder: 'Entrez l\'URL du logo (optionnel)',
    logoUrlHelp: 'Entrez une URL valide vers l\'image du logo de la marque',
    searchBrands: 'Rechercher des marques...',
    noBrands: 'Aucune marque trouvée',
    
    // Model management
    modelName: 'Nom du Modèle',
    brand: 'Marque',
    yearRange: 'Plage d\'Années',
    yearStart: 'Année de Début',
    yearEnd: 'Année de Fin',
    addModel: 'Ajouter un Modèle',
    editModel: 'Modifier le Modèle',
    deleteModel: 'Supprimer le Modèle',
    addModelDescription: 'Ajouter un nouveau modèle de voiture au système',
    editModelDescription: 'Modifier le modèle de voiture sélectionné',
    deleteModelConfirm: 'Êtes-vous sûr de vouloir supprimer le modèle "{{name}}" ? Cette action ne peut pas être annulée.',
    modelNamePlaceholder: 'Entrez le nom du modèle (ex: Camry)',
    selectBrand: 'Sélectionner une marque',
    filterByBrand: 'Filtrer par marque',
    allBrands: 'Toutes les Marques',
    searchModels: 'Rechercher des modèles...',
    noModels: 'Aucun modèle trouvé',
    yearRangeHelp: 'Laissez vide si le modèle est encore en production',
    preSelectedBrand: 'Marque présélectionnée',
    
    // Models Dialog
    modelsDialog: {
      title: '{{brandName}} - Modèles',
      description: 'Gérer les modèles pour {{brandName}}',
      addModel: 'Ajouter un Modèle',
      noModels: 'Aucun modèle pour cette marque',
      modelsList: 'Liste des Modèles'
    },
    modelsCount: '{{count}} Modèles',
    viewModels: 'Voir les Modèles',
    
    // Success messages
    success: {
      brandCreated: 'Marque créée avec succès',
      brandUpdated: 'Marque mise à jour avec succès',
      brandDeleted: 'Marque supprimée avec succès',
      modelCreated: 'Modèle créé avec succès',
      modelUpdated: 'Modèle mis à jour avec succès',
      modelDeleted: 'Modèle supprimé avec succès'
    },
    
    // Error messages
    errors: {
      fetchBrands: 'Échec du chargement des marques',
      fetchModels: 'Échec du chargement des modèles',
      createBrand: 'Échec de la création de la marque',
      updateBrand: 'Échec de la mise à jour de la marque',
      deleteBrand: 'Échec de la suppression de la marque',
      createModel: 'Échec de la création du modèle',
      updateModel: 'Échec de la mise à jour du modèle',
      deleteModel: 'Échec de la suppression du modèle',
      saveBrand: 'Échec de la sauvegarde de la marque',
      saveModel: 'Échec de la sauvegarde du modèle',
      brandHasModels: 'Impossible de supprimer une marque qui a des modèles associés'
    },
    
    // Validation messages
    validation: {
      nameRequired: 'Le nom de la marque est requis',
      modelNameRequired: 'Le nom du modèle est requis',
      brandRequired: 'La sélection de la marque est requise',
      invalidUrl: 'Veuillez entrer une URL valide',
      yearEndMustBeAfterStart: 'L\'année de fin doit être après l\'année de début',
      invalidYearStart: 'Année de début invalide',
      invalidYearEnd: 'Année de fin invalide'
    }
  },

  // WhatsApp Action Settings
  whatsapp: {
    actions: {
      title: 'Actions de Notification',
      description: 'Contrôlez quelles actions déclenchent les notifications WhatsApp et sélectionnez les modèles pour chaque action',
      new_booking: {
        name: 'Nouvelle Réservation Reçue',
        description: 'Notifier le propriétaire de l\'agence lorsqu\'une nouvelle réservation est créée'
      },
      booking_confirmed: {
        name: 'Réservation Confirmée',
        description: 'Notifier le propriétaire de l\'agence lorsqu\'une réservation est confirmée'
      },
      booking_cancelled: {
        name: 'Réservation Annulée',
        description: 'Notifier le propriétaire de l\'agence lorsqu\'une réservation est annulée'
      },
      client_registered: {
        name: 'Nouveau Client Enregistré',
        description: 'Notifier le propriétaire de l\'agence lorsqu\'un nouveau client est enregistré'
      },
      vehicle_added: {
        name: 'Véhicule Ajouté',
        description: 'Notifier le propriétaire de l\'agence lorsqu\'un véhicule est ajouté à la flotte'
      },
      vehicle_removed: {
        name: 'Véhicule Supprimé',
        description: 'Notifier le propriétaire de l\'agence lorsqu\'un véhicule est retiré de la flotte'
      },
      payment_reminder: {
        name: 'Rappel de Paiement',
        description: 'Envoyer des rappels de paiement aux clients'
      },
      selectTemplate: 'Sélectionner un modèle',
      saveActions: 'Sauvegarder les Actions',
      saving: 'Sauvegarde...',
      actionsSaved: 'Paramètres d\'action sauvegardés avec succès',
      actionsSaveError: 'Échec de la sauvegarde des paramètres d\'action'
    }
  }
}; 